import { render, staticRenderFns } from "./LaporanList.vue?vue&type=template&id=79e7c2aa&"
import script from "./LaporanList.vue?vue&type=script&lang=js&"
export * from "./LaporanList.vue?vue&type=script&lang=js&"
import style0 from "./LaporanList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LaporanList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports